module.exports = {
  AudioCue: {
    config: "Configuración",
    PluginName: "Señal de audio",
    AutoPlay: "Reproducir automáticamente",
    URL: "URL del audio",
    Image: "URL de la imagen",
    Color: "Color",
    UseImage: "Usar imagen",
    HideAnimation: "Ocultar animación",
    PlayerView: "Vista de reproductor",
    IsSoundRecord: "Grabar Sonido",
    SoundRecorder: "Pasando el Tiempo",
    Start: "Comienzo",
    Stop: "Parada",
    SoundRecording: "Se está grabando sonido...",
    SoundRecorded: "Audio Grabado.",
    SelectSoundProvider: "Agregar Pista de Audio",
    AddSound: "Agregar",
    EndTime: "Hora de finalización en la diapositiva",
    StartTime: "Hora de inicio en la diapositiva",
    Save: "Guardar",
  },
};
